module.exports = __webpack_public_path__ + "img/title_bg.cc6fabe0.png";